
// services/league_service.js
import { getLeagueRequest, getLeagueByIdRequest } from "../repositories/league_repository";

export const LeagueService = () => {
  const fetchLeague = async (setData = null) => {
    try {
      const result = await getLeagueRequest();
      if (result.success) {
        if (setData) setData(result.data);
        return result.data;
      } else {
        throw new Error(result.errors || "Failed to fetch leagues");
      }
    } catch (error) {
      console.error("Error in fetchLeague:", error);
      throw error;
    }
  };

  const fetchLeagueById = async (id) => {
    try {
      const result = await getLeagueByIdRequest(id);
      if (result.success) {
        return result.data;
      } else {
        throw new Error(result.errors || `Failed to fetch league with ID: ${id}`);
      }
    } catch (error) {
      console.error("Error in fetchLeagueById:", error);
      throw error;
    }
  };

  return {
    fetchLeague,
    fetchLeagueById
  };
};